"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingSource = void 0;
/*
 * Copyright (c) 2025 MTa VELA. All Rights Reserved.
 *
 * MTa VELA proprietary information: the enclosed materials contain proprietary information of MTa VELA and shall not be
 * disclosed in whole or in any part to any third party or used by any person for any purpose, without written consent
 * of MTa VELA. Duplication of any portion of these materials shall include this notice.
 */
/**
 * Some possible sources from which a customer heard about MTa, used for marketing/analytics
 * purposes during the checkout process.
 */
var MarketingSource;
(function (MarketingSource) {
    /** Customer was recommended by someone. */
    MarketingSource["RECOMMENDATION"] = "recommendation";
    /** Customer previously used MTa Kits. */
    MarketingSource["PREVIOUSLY_USED_MTA_KITS"] = "previously-used-mta-kits";
    /** Customer found us via a LinkedIn advertisement. */
    MarketingSource["LINKEDIN_ADVERT"] = "linkedin-advert";
    /** Customer found us via other social media platforms. */
    MarketingSource["SOCIAL_MEDIA"] = "social-media";
    /** Customer found us via Google Search. */
    MarketingSource["GOOGLE_SEARCH"] = "google-search";
    /** Customer found us via an unlisted source, typically requiring further information. */
    MarketingSource["OTHER"] = "other";
})(MarketingSource || (exports.MarketingSource = MarketingSource = {}));
